import { defineMessages } from 'react-intl';

export const messages: {
	liveDoc: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	statusUpdateTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	issue: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	talentExternalPositionKey: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	talentPositionTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	code: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	riskIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	liveDoc: {
		id: 'live_doc_type',
		defaultMessage: 'Live Doc',
		description:
			'Content type badge shown on a search result card in the Quick Find dialog to indicate the result is a Live Doc (a collaborative real-time document).',
	},
	statusUpdateTitle: {
		id: 'quick-find.mercury.focus-area-status-update.title',
		defaultMessage: 'Update for {focusAreaName}',
		description:
			'Title shown on a search result card for a focus area status update in the Quick Find dialog. The placeholder {focusAreaName} will be substituted with the name of the focus area.',
	},
	issue: {
		id: 'issue_type',
		defaultMessage: 'Work item',
		description:
			'Content type badge shown on a search result card in the Quick Find dialog to indicate the result is a Jira work item (issue).',
	},
	talentExternalPositionKey: {
		id: 'quick-find.talent.position.external-position-key',
		defaultMessage: 'External key {positionKey}',
		description:
			'Metadata label shown on a talent position search result card in the Quick Find dialog. The placeholder {positionKey} will be substituted with the external identifier for the position.',
	},
	talentPositionTitle: {
		id: 'quick-find.talent.position.title',
		defaultMessage:
			'{preferredName, select, undefined {{positionKey}} other {{positionKey}: {preferredName}}}',
		description:
			'Title shown on a talent position search result card in the Quick Find dialog. The placeholder {positionKey} is the position identifier and {preferredName} is the preferred job title; when no preferred name exists, only the key is shown.',
	},
	code: {
		id: 'quick-find.github.code.type',
		defaultMessage: 'Code',
		description:
			'Content type badge shown on a search result card in the Quick Find dialog to indicate the result is a GitHub source code file.',
	},
	riskIconLabel: {
		id: 'quick-find.mercury.risk.icon-label',
		defaultMessage: 'Risk',
		description:
			'Accessible label read by screen readers for the icon on a Mercury risk search result card in the Quick Find dialog.',
	},
});
